import { render, staticRenderFns } from "./CreditorPage.vue?vue&type=template&id=62303658&scoped=true&"
import script from "./CreditorPage.vue?vue&type=script&lang=js&"
export * from "./CreditorPage.vue?vue&type=script&lang=js&"
import style0 from "./CreditorPage.vue?vue&type=style&index=0&id=62303658&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62303658",
  null
  
)

export default component.exports